export default "__VITE_ASSET__D5gD9gyG__"